import { render, staticRenderFns } from "./horizontalSlidePage.vue?vue&type=template&id=30a748db&"
import script from "./horizontalSlidePage.vue?vue&type=script&lang=ts&"
export * from "./horizontalSlidePage.vue?vue&type=script&lang=ts&"
import style0 from "./horizontalSlidePage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports